import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Globals } from '../global-variables/globals';

@Component({
    selector: 'app-screen-message',
    templateUrl: './screen-message.component.html',
    styleUrls: ['./screen-message.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScreenMessageComponent implements OnInit {

  @Input() messages: Array<String> = [];
  @Input() errors: Array<String> = [];
  constructor(public globals: Globals) { }


  ngOnInit() {
  }
}
